<template>
<div id="web-guide">
  <div class="web-logo"></div>
  <div class="web-title">全新搜索</div>
  <div class="web-subtitle">课件、新闻 — 快速、精准搜索</div>
  <div class="web-phone"></div>
  <div id="news-ads">
    <div class="ads-img"></div>
    <div class="ads-title">中消在线，消防一站式服务平台</div>
    <div class="ads-click" v-on:click="downloadClick">下载APP</div>
  </div>
</div>
</template>

<script>
import wxShare from '../../wx/weixin.js'
// 引入
import {Toast} from 'mint-ui'
export default{
  data () {
    return {
    }
  },
  mounted: function () {
    // 微信 分享
    wxShare.wxRegister('中消在线', '消防一站式服务平台', 'http://cdn.zxzx119.com/18838104261525504')

    // 统计
    this.utils.listenEvent(2, '', window.location.href, '')

    var _this = this
    setTimeout(function () {
      if (_this.utils.isIphoneX()) {
        document.getElementById('news-ads').style.height = '70px'
      }
    }, 50)
  },
  watch: {
    $route () {
    }
  },
  methods: {
    downloadClick: function () {
      // 统计
      this.utils.listenEvent(4, '', window.location.href, '')

      if (!this.utils.isIphone()) {
        if (this.utils.isWX()) {
          Toast('下载app，请打开右上方浏览器打开下载')
        }
      }

      if (this.utils.isIphone()) {
        window.location.href = 'https://itunes.apple.com/cn/app/id1301911560?mt=8'
      } else {
        window.location.href = 'http://cdn.zxzx119.com/zxzx.apk'
      }
    }
  }
}
</script>

<style scoped="scoped">
body {
    padding-top: constant(safe-area-inset-top);
    padding-left: constant(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
    padding-bottom: constant(safe-area-inset-bottom);
}

#web-guide{
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/web_bg.jpg);
  background-size: cover;
  background-position: center center;
  overflow: hidden;
}
.web-logo{
  position: absolute;
  top: 55px;
  text-align: center;
  width: 100%;
  height: 78px;
  background-image: url(../../assets/web_logo.png);
  background-size: 77px 78px;
  background-position: center center;
  background-repeat: no-repeat;
}
.web-title{
  position: absolute;
  width: 100%;
  height: 30px;
  top: 150px;
  color: #FFFFFF;
  font-size: 26px;
  font-weight: bold;
  text-align: center;
}
.web-subtitle{
  position: absolute;
  width: 100%;
  height: 30px;
  top: 190px;
  color: #FFFFFF;
  font-size: 19px;
  text-align: center;
}
.web-phone{
  position: absolute;
  top: 240px;
  text-align: center;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/web_phone.png);
  background-size: 95%;
  background-position: top center;
  background-repeat: no-repeat;
  /*background-color: yellow;*/
}

#news-ads{
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  height: 60px;
      background: rgba(0, 0, 0, 0.7);
}
#news-ads .ads-img{
  position: absolute;
  top: 12px;
  left: 10px;
  width: 40px;
  height: 40px;
  background-image: url(../../assets/web_logo.png);
  background-size: cover;
  background-position: center center;

}
#news-ads .ads-title{
  position: absolute;
  top: 10px;
  left: 55px;
  width: 250px;
  height: 40px;
  line-height: 40px;
  color: #FFFFFF;
  font-size: 15px;
}
#news-ads .ads-click{
  position: absolute;
  float: right;
  top: 15px;
  right: 10px;
  width: 70px;
  height: 30px;
  line-height: 30px;
  background-color: #c41335;
  border-radius: 15px;
  color: #FFFFFF;
  font-size: 13px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/view/app/web-guide.vue